import {getCurrentInstance, nextTick} from "vue";
import axios from "axios";

export const isProd = () => {
    return location.href.search('mango-office') > -1;
};
export const getDomain = () => {
    return process.env.VUE_APP_DOMAIN !== undefined ? process.env.VUE_APP_DOMAIN : '';
};
export const getApiUrl = () => {
    const app = getCurrentInstance();
    return getDomain() + '/api/' + pascalCaseToKebab(app.type.name) + '/'
};
export const pascalCaseToKebab = (string) => {
    const camelCaseString = string.charAt(0).toLowerCase() + string.slice(1);
    return camelCaseString.replace(/[A-Z]?([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};

export const createFromStructure = (structure) => {
    let result = {};
    for (let fieldName in structure) {
        result[fieldName] = structure[fieldName]['default_value'];
    }
    return result;
}

export const translit = (string, replace = false) => {
    let map = {
        "а": "a",
        "б": "b",
        "в": "v",
        "г": "g",
        "д": "d",
        "е": "e",
        "ё": "ye",
        "ж": "zh",
        "з": "z",
        "и": "i",
        "й": "y",
        "к": "k",
        "л": "l",
        "м": "m",
        "н": "n",
        "о": "o",
        "п": "p",
        "р": "r",
        "с": "s",
        "т": "t",
        "у": "u",
        "ф": "f",
        "х": "kh",
        "ц": "ts",
        "ч": "ch",
        "ш": "sh",
        "щ": "shch",
        "ъ": "",
        "ы": "y",
        "ь": "",
        "э": "e",
        "ю": "yu",
        "я": "ya",
        "А": "A",
        "Б": "B",
        "В": "V",
        "Г": "G",
        "Д": "D",
        "Е": "E",
        "Ё": "YE",
        "Ж": "ZH",
        "З": "Z",
        "И": "I",
        "Й": "Y",
        "К": "K",
        "Л": "L",
        "М": "M",
        "Н": "N",
        "О": "O",
        "П": "P",
        "Р": "R",
        "С": "S",
        "Т": "T",
        "У": "U",
        "Ф": "F",
        "Х": "KH",
        "Ц": "TS",
        "Ч": "CH",
        "Ш": "SH",
        "Щ": "SHCH",
        "Ъ": "",
        "Ы": "Y",
        "Ь": "",
        "Э": "E",
        "Ю": "YU",
        "Я": "YA",
        "і": "i",
        "І": "I",
        "ї": "i",
        "Ї": "I",
        "ґ": "g",
        "Ґ": "G"
    }
    let result = '';
    for (let i in string) {
        result += map[string[i]] !== undefined ? map[string[i]] : string[i];
    }

    if (replace) {
        for (let k in replace) {
            result = result.replaceAll(k, replace[k]);
        }
    }

    return result;
}

export const checkDataElement = (id) => {
    return window.location.href.search('mango-office.ru') > -1 ? false : id;
}

export const validateEntity = (entity, structure, fieldName = false, hiddenFields = []) => {
    let errorFields = [];
    for (let k in structure) {
        if (!fieldName || fieldName === structure[k]['name']) {
            if (hiddenFields.indexOf(k) > -1 || structure[k]['editable'] === false) {
                continue;
            }
            let fieldStructure = structure[k];
            let value = entity[fieldStructure.name];

            if (fieldStructure['validators']) {
                for (let i in fieldStructure['validators']) {
                    let validator = fieldStructure['validators'][i];
                    switch (validator['type']) {
                        case 'failRegexp':
                            if (validator['params'] !== undefined && validator['params'].test(value)) {
                                errorFields.push(fieldStructure.name);
                                fieldStructure.error = true;
                            }
                            break;
                        case 'maxLen':
                            if (validator['params'] !== undefined && value.length > validator['params']) {
                                errorFields.push(fieldStructure.name);
                                fieldStructure.error = true;
                            }
                            break;
                    }
                }
            }
        }
    }
    return errorFields;
}

export const checkRequiredFields = (entity, structure, fieldName = false, hiddenFields = []) => {
    let errorFields = []
    for (let k in structure) {
        if (hiddenFields.indexOf(k) > -1 || structure[k]['editable'] === false) {
            continue;
        }
        if (!fieldName || fieldName === structure[k]['name']) {
            let fieldStructure = structure[k];
            fieldStructure.error = false;
            let value = entity[fieldStructure.name];
            if (typeof value === 'string') {
                value = value.trim();
            }
            if (fieldStructure['required'] === true && (!value || value.length === 0)) {
                errorFields.push(fieldStructure.name);
            }
        }
    }
    return errorFields;
}



